<form [formGroup]="form">
  <mat-form-field>
    <mat-label>{{ title }}</mat-label>
    <input formControlName="income" matInput spbFormatNumber>
    <span [style.white-space]="'nowrap'" matTextSuffix>{{ suffix }}</span>
    <mat-hint>{{ hint }}</mat-hint>
  </mat-form-field>
</form>